const doc = [({"zh_tw":({"adminComponentHotelFilter":({"addFilter":"添加篩選條件", "hotelFilterTitle":"篩選條件設定"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;